// extracted by mini-css-extract-plugin
export default {"container":"WM-z","timeTop":"XM-z","timeCountdown":"YM-z","cta":"ZM-z","disabled":"_M-z","product":"aN-z"};